import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Dumbbell, HeartPulse, Plus, Ruler } from 'lucide-react';

const ITEMS = [
  { to: '/cardio?log=1', icon: Activity, label: 'Cardio workout' },
  { to: '/strength?log=1', icon: Dumbbell, label: 'Strength workout' },
  { to: '/body?log=1', icon: Ruler, label: 'Body measurement' },
  { to: '/health?log=1', icon: HeartPulse, label: 'Day metrics' },
];

/** "+" in the header — jump to any section with its log modal pre-opened (?log=1). */
export function QuickAdd() {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="quick-add" ref={rootRef}>
      <button
        type="button"
        className="quick-add-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <Plus size={16} strokeWidth={2.5} />
        Log
      </button>
      {open && (
        <div className="quick-add-menu" role="menu">
          {ITEMS.map(({ to, icon: Icon, label }) => (
            <button
              key={to}
              type="button"
              role="menuitem"
              className="quick-add-item"
              onClick={() => {
                setOpen(false);
                navigate(to);
              }}
            >
              <Icon size={15} strokeWidth={2} />
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
